'use client';

import { useTranslation } from 'react-i18next';
import Logo from '../../ui/navigation/top-menu/logo';
import { JSection } from '../../ui/layout';

function Footer() {
    const { t } = useTranslation('about-footer');
    return (
        <div className="flex w-full flex-col items-center bg-[#EEEEEE]">
            <JSection
                size="lg"
                padding="md"
                spacing="none"
                className="flex w-full flex-col items-center py-[32px] sm:py-[60px]"
            >
                <div className="flex w-full flex-col items-center justify-center">
                    <div className="j-h3 w-full">{t('title')}</div>
                    <div className="mt-[24px] flex w-full items-center justify-end sm:mt-0">
                        ——
                        <Logo height={28} width={107} color="black" />
                    </div>
                </div>
            </JSection>
        </div>
    );
}

export default Footer;
